export type CsFeature = {
  id: string;
  label: string;
  color: string;
};

const COLOR_AZURE_BLUE = '#1976d2';
const COLOR_FOREST_GREEN = '#2e7d32';
export const COLOR_WHITE = '#fff';

/**
 * Registry of trackable CS features.
 * To add a new feature: append one entry here and ensure the owning service
 * fires a `cs_agent_feature_used` Snowplow event with the matching featureId.
 */
export const CS_FEATURES: CsFeature[] = [
  {
    id: 'sms-verify',
    label: 'SMS Verification',
    color: COLOR_AZURE_BLUE,
  },
  {
    id: 'ai-call-summary',
    label: 'AI Call Summary',
    color: COLOR_FOREST_GREEN,
  },
];

export const CS_FEATURE_MAP: Record<string, CsFeature> = Object.fromEntries(
  CS_FEATURES.map((feature) => [feature.id, feature]),
);
